import { useRef } from "react"

export const useOnHold = (callback: () => void, interval = 21, delay = 500) => {
    const intervalRef = useRef<number | null>(null)
    const timeoutRef = useRef<number | null>(null)

    const start = () => {
        stop()

        callback()

        timeoutRef.current = window.setTimeout(() => {
            intervalRef.current = window.setInterval(callback, interval)
        }, delay)
    }

    const stop = () => {
        if (timeoutRef.current) {
            window.clearTimeout(timeoutRef.current)
            timeoutRef.current = null
        }

        if (intervalRef.current) {
            window.clearInterval(intervalRef.current)
            intervalRef.current = null
        }
    }

    return {
        onMouseDown: start,
        onMouseUp: stop,
        onMouseLeave: stop,
        onTouchStart: start,
        onTouchEnd: stop,
    }
}
